<template>
<div class="container">
    <div class="row d-flex mb-4 justify-content-end">
        <div class="col-12 mb-2" v-if="!newCompany">
            <Button @click="$router.push('/group')" size="small" type="outline" color="grey">
                <ArrowDropdown :rotate="90" /> Voltar
            </Button>
        </div>
        <div class="col-8 d-flex align-items-end">
            <h3 class="c-ndarkthree">
                <span class="bold">{{headerTitle}}</span> | Gerenciar cedentes
            </h3>
        </div>
        <el-dropdown trigger="click" class="col-4 pb-2 d-flex justify-content-end">
            <Button :color="getPrimaryColor" class="pl-4 pr-4">
                <span>Novo cedente</span>
                <ArrowDropdown class="ml-3" color="#white" rotate="360"/>
            </Button>
            <el-dropdown-menu slot="dropdown">
                <ActionBtnItemsContainer :withoutBottomLine="false">
                    <el-dropdown-item>
                        <span class="c-ndarkthree medium pl-3 pr-3 d-flex align-items-center" @click="newProvider()">
                            <svg class="mr-2" width="15" height="15" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.99983 1V9M1 5H8.99967" stroke="#A1A8B8" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            Cadastrar um cedente
                        </span>
                    </el-dropdown-item>
                    <el-upload
                        action="not"
                        :auto-upload="false"
                        :limit="3"
                        :show-file-list="false"
                        :on-change="handleFileChange"
                        :file-list="fileList"
                        accept=".xls,.xlsx"
                    >
                        <el-dropdown-item>
                            <span class="c-ndarkthree medium pl-3 pr-3 d-flex align-items-center">
                                <Upload size="15" color="#A1A8B8" class="mr-2" />
                                Cadastrar cedentes em lote
                            </span>
                        </el-dropdown-item>
                    </el-upload>
                </ActionBtnItemsContainer>
                <ActionBtnItemsContainer :withoutBottomLine="true">
                    <el-dropdown-item @click.native="handleSpreadsheetDownload">
                        <span class="c-ndarkthree medium pl-3 pr-3 d-flex align-items-center">
                            <Download size="15" color="#A1A8B8" class="mr-2" />
                            Baixar modelo de planilha
                        </span>
                    </el-dropdown-item>
                </ActionBtnItemsContainer>
            </el-dropdown-menu>
        </el-dropdown>
        <div class="col-12 mt-4 pt-2 d-flex align-items-center justify-content-end">
            <div class="ml-2">
                <el-input  
                    v-model="search"
                    placeholder="Buscar"
                    :class="`${getPrimaryColor} filter`"
                    @keyup.native.enter="getGroup"
                    clearable
                >
                    <button class="btn" slot="append" @click="getGroup">
                        <SearchIcon class="mx-0" size="16" />
                    </button>
                </el-input>
                <h6 slot="append" class="regular">
                    Busque pelo nome ou CNPJ da empresa.<br> Ex.: <span :class="`c-${getPrimaryColor}four`"> Uni Impacta. </span>
                </h6>
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <TableContainer
                :isLoading="isLoading"
                :pagination="pagination"
                :hasTable="providers.length"
                @updatePage="updatePage($event)"
            >
                <ManageProviderGroup 
                    :tableData="providers" 
                    @providerDeleted="getGroup"
                />
            </TableContainer>
            <EmptyGroup 
                v-if="!isLoading && !providers.length && !search" 
                :isProvider="true"
            />
            <NotFound 
                v-else-if="!isLoading && !providers.length && search"
            />
        </div>
    </div>
    <FullLoading :color="getPrimaryColorHex.five" v-if="$store.state.user.loading" :text="loadingText"/>
    <ProcessingProvidersOrBuyers 
        company="provider"
        :dialogVisible="dialogVisible"
        @closeModal="redirectAfterImport"
    />
    <NewCompanyEG v-if="newCompany"/>
</div>
</template>

<script>
import ArrowDropdown from '@/components/icons/ArrowDropdown'
import Download from '@/components/icons/Download'
import Upload from '@/components/icons/Upload'
import ManageProviderGroup from '@/components/tables/ManageProviderGroup'
import getEconomicGroupProviders from '@/api/getEconomicGroupProviders'
import importProvidersEconomicGroup from '@/api/importProvidersEconomicGroup'
import downloadArchive from '@/api/downloadArchive'
import NotFound from '@/components/emptyOrNotFound/NotFound'
import EmptyGroup from '@/components/emptyOrNotFound/EmptyGroup'
import TableContainer from '@/components/tables/TableContainer'
import ActionBtnItemsContainer from '@/components/container/ActionBtnItemsContainer.vue'
import FullLoading from '@/components/loading/FullLoading'
import ProcessingProvidersOrBuyers from '@/components/modals/ProcessingProvidersOrBuyers.vue'
import NewCompanyEG from '@/components/cards/NewCompanyEG'

export default {
    components: {
        ManageProviderGroup,
        ArrowDropdown,
        NotFound,
        EmptyGroup,
        TableContainer,
        Download,
        Upload,
        ActionBtnItemsContainer,
        ProcessingProvidersOrBuyers,
        FullLoading,
        NewCompanyEG,
    },
    data() {
        return {
            search: '',
            providers: [],
            isLoading: false,
            pagination: {},
            page: 1,
            group: {},
            dialogVisible: false,
            newCompany: !this.$route.path.includes('edit'),
        }
    },
    computed: {
        headerTitle() {
            const title = this.newCompany ? 'Novo grupo econômico' : this.group.name
            return title
        },
        groupId() {
            return this.$route.params.groupId
        },
        filters(){
            return {
                page: this.page,
                search: this.search,
                lean: true,
            }
        },
    },
    methods: {
        newProvider() {
            this.$router.push(`/group/${this.$route.params.groupId}/company/new/1`)
        },
        async getGroup() {
            this.isLoading = true
            const result = await getEconomicGroupProviders(this.groupId, this.filters)
            this.group = result?.data?.payload?.rows || {}
            this.providers = this.group.providers || []
            this.pagination = result?.data?.payload?.pagination || {}
            this.isLoading = false
        },
        async updatePage(page) {
            this.page = page
            await this.getGroup()
        },
        toBase64: file => new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        }),
        async handleFileChange(file) {
            this.loadingText = 'Importando fornecedores...'
            const base64File = await this.toBase64(file.raw)
            const base64Header = base64File.indexOf(',') + 1
            const fileData = {
                economicGroupId: parseInt(this.$route.params.groupId),
                providerFile: base64File.slice(base64Header , base64File.length)
            }
            const result = await importProvidersEconomicGroup(fileData)
            if (result.data.ok) {
                this.dialogVisible = true
            }
            this.loadingText = 'Carregando...'
        },
        redirectAfterImport() {
            this.fileList = []

            if(this.newCompany) {
                window.location.reload()
            } else {
                this.$router.push(`/group`)
            }
            
            this.dialogVisible = false
        },
        handleSpreadsheetDownload() {
            downloadArchive('https://v3.cashforce.com.br/clients/assets/templates/template_cnpj_cedentes.xlsx', '', {})
        },
    },
    created() {
        this.getGroup()
    }
}
</script>

<style lang="scss" scoped>

</style>
